module.exports = __webpack_public_path__ + "static/media/Stellar Vox Single Headboard - 120 cm_Cream.ef7b1fe8.png";